<template>
  <div class="container-warp">
    <!-- <Top-Nav pageTitle="试题库"
             @click-left="pageBack"></Top-Nav> -->
    <van-nav-bar title="试题库"
                 left-arrow
                 @click-left="pageBack"
                 @click-right="openSearch"
                 fixed
                 z-index="99">
      <template #right>
        <van-icon name="search"
                  size="20" />
      </template>
    </van-nav-bar>
    <van-list v-model="loading"
              :finished="finished"
              finished-text="没有更多了"
              @load="onLoad">
      <van-cell-group inset
                      v-for="item in list"
                      :key="item.id"
                      class="list-item">
        <div class="list-item-hd">{{item.questionTypeNm}}</div>
        <div class="list-item-bd">
          <p class="van-multi-ellipsis--l2">试题题目：{{item.shortTitle}}</p>
          <p class="text-gray">所属题库：{{ item.bankName }}</p>
        </div>
        <div class="list-item-foot">
          <van-button type="info"
                      size="small"
                      @click="onDetail(item)"
                      icon="description-o">详情</van-button>
        </div>
      </van-cell-group>
    </van-list>
    <!-- 搜索过滤 -->
    <Search-filter ref="SearchFilter"
                   @handle-filter="submitFilter"></Search-filter>
  </div>
</template>

<script>
import { examQuestionList } from "@/api/examQuestionBank.js";
import SearchFilter from "./components/search-filter.vue";
export default {
  name: 'ExamQuestionBank',
  components: {
    SearchFilter
  },
  data() {
    return {
      list: [],
      total: 0,
      loading: false,
      finished: false,
      pageNum: 1,
      pageSize: 20,
      searchParams: {
        bankName: "",
        questionTag: "",
        questionType: "",
        content: "",
        status: "1"
      }
    }
  },
  methods: {
    async onLoad() {
      const params = {
        pageIndex: this.pageNum,
        pageSize: this.pageSize,
        openPractice:1,
        ...this.searchParams,
      }
      // console.log(params)
      const { status, response } = await examQuestionList(params);
      if (status == 200) {
        let records = response.list || [];
        this.list.push(...records)
        this.total = response.total;
        this.pageNum++;
        // 数据全部加载完成
        if (this.list.length >= this.total) {
          this.finished = true;
        } else {
          this.finished = false;
        }
        // 加载状态结束
        this.loading = false;
      }
    },

    // 查看详情
    onDetail(row) {
      this.$router.push({ path: '/questionDetails', query: { id: row.id } })
    },
    resetList() {
      this.pageNum = 1;
      this.list = []
      this.finished = false;
      this.loading = false;
    },
    openSearch() {
      this.$refs.SearchFilter.open()
    },
    async submitFilter(params) {
      this.pageNum = 1;
      this.searchParams = { ...params }
      const queryParams = {
        pageIndex: this.pageNum,
        pageSize: this.pageSize,
        openPractice:1,
        ...this.searchParams
      }
      // console.log(queryParams)
      const { status, response } = await examQuestionList(queryParams);
      if (status == 200) {
        this.list = [...response.list]
        this.total = response.total;
        this.pageNum++;
        // 数据全部加载完成
        if (this.list.length >= this.total) {
          this.finished = true;
        } else {
          this.finished = false;
        }
        // 加载状态结束
        this.loading = false;
      }
    },
    pageBack() {
      this.$router.push({ path: '/index' })
    },
  },
}
</script>

<style lang="less" scoped>
@import url("~@/assets/css/list-style.less");
</style>
